
import { Field } from "@/utils/documents/field";
import { FreeBlock } from "@/utils/documents/free-block";
import Vue from "vue";
import AppDraggableResizeCombo from "@/components/layout-editor/DraggableResizeCombo.vue";

export default Vue.extend({
	props: {
		freeBlock: {
			type: Object as ()=>FreeBlock,
			required: true
		},
		lang: String
	},
	methods: {
		getPropValue(prop: Field): string {
			if (!prop.Prop) return "";
			return "<span class='field'>" + this.$t("models.map.Sale." + prop.Prop).toString() + "</span>";
		},
		getLineText(line:Field):string{
			let text =  line.Text.getTranslation(this.lang) + this.getPropValue(line) + line.TextAfter.getTranslation(this.lang);
			if (text == ""){
				return "&#8203;";
			}
			return text;
		}
	},
	components: {
		AppDraggableResizeCombo,
	}
});
